import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import * as en_stops from '../../stops';
import * as es_stops from '../../stops.es';

@Component({
  selector: 'app-welcome-tour-stop',
  templateUrl: './welcome-tour-stop.component.html',
  styleUrls: ['./welcome-tour-stop.component.scss']
})
export class WelcomeTourStopComponent implements OnInit {
  welcomeTourStopTranslation: Record<string, string> = {};

  @Output() hide = new EventEmitter<void>();

  constructor(private router: Router) {
    let isSpanish = router.url.slice(0, 4) == "/es" || router.url.slice(0, 4) == "/es/";
    if(isSpanish){
      this.welcomeTourStopTranslation = es_stops.WELCOMETOURSTOP
    }else{
      this.welcomeTourStopTranslation = en_stops.WELCOMETOURSTOP
    }
   }

  ngOnInit(): void {
  }

}
